module.exports = __webpack_public_path__ + "img/lifecoach4.80754132.jpg";